import { render, staticRenderFns } from "./NepaliDatePicker.vue?vue&type=template&id=f1756246"
import script from "./NepaliDatePicker.vue?vue&type=script&lang=js"
export * from "./NepaliDatePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports